import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { gbp, toPence } from "@/lib/format";

export default function StatementLines({ lines, setLines }) {
  const upd = (i, k, v) => setLines(lines.map((l, j) => (j === i ? { ...l, [k]: v } : l)));
  const sum = (t) => lines.filter((l) => l.type === t).reduce((s, l) => s + (toPence(l.amount) || 0), 0);
  return (
    <div className="space-y-2 rounded-2xl bg-slate-50 p-3" data-testid="statement-lines-preview">
      <p className="text-sm font-semibold">Check the lines read from the statement</p>
      <div className="max-h-80 space-y-1.5 overflow-y-auto pr-1">
        {lines.map((l, i) => (
          <div key={i} className="grid grid-cols-12 gap-1.5" data-testid={`statement-line-${i}`}>
            <select value={l.type} onChange={(e) => upd(i, "type", e.target.value)} className="col-span-3 h-9 rounded-md border border-input bg-white px-1 text-sm" data-testid={`statement-line-type-${i}`}>
              <option value="INV">INV</option><option value="CRN">CRN</option>
            </select>
            <Input className="col-span-4 font-mono" value={l.ref} onChange={(e) => upd(i, "ref", e.target.value)} data-testid={`statement-line-ref-${i}`} />
            <Input className="col-span-4 font-mono" inputMode="decimal" value={l.amount} onChange={(e) => upd(i, "amount", e.target.value)} data-testid={`statement-line-amount-${i}`} />
            <Button type="button" variant="ghost" size="icon" className="col-span-1" onClick={() => setLines(lines.filter((_, j) => j !== i))} data-testid={`statement-line-remove-${i}`}><Trash2 className="h-4 w-4" /></Button>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-between">
        <Button type="button" variant="outline" size="sm" onClick={() => setLines([...lines, { type: "INV", ref: "", amount: "" }])} data-testid="statement-add-line-button"><Plus className="mr-1 h-4 w-4" /> Add line</Button>
        <p className="text-xs text-slate-600" data-testid="statement-lines-totals">{lines.length} lines · INV <b className="font-mono">{gbp(sum("INV"))}</b> · CRN <b className="font-mono">{gbp(sum("CRN"))}</b></p>
      </div>
    </div>
  );
}
